import {
  type ExpressionElement,
  type Expression,
} from '@packages/systems/wfdl-ast';
import {getElementWithAncestors} from '@packages/utilities/core-elements';
import {isProjectingElement} from '@packages/utilities/elementTypeUtils';

export const getAncestorProjectingElements = (
  elementId: string,
  tree: Expression
): Array<ExpressionElement> => {
  return getElementWithAncestors(tree)(elementId).filter(isProjectingElement);
};

export const countAncestorProjectingElements = (
  elementId: string,
  tree: Expression
): number => getAncestorProjectingElements(elementId, tree).length;
